import { ColorKeys, Flex, Text, scale } from "@capioweb/ui-components"
import React from "react"
import styled from "styled-components"
import { ContentAreaProperty } from "../../@types/CapioWeb/core"
import {
	BooleanProperty,
	StringProperty,
} from "../../@types/EpiFoundationSpa/Property"
import { BlockCommonLayout } from "../../utils/layout"
import { getContentByType } from "../Core"

interface SectionBlockProps {
	mainContent: ContentAreaProperty
	value: ContentAreaProperty
	heading: StringProperty
	backgroundColor: ColorKeys
	marginBottom?: BooleanProperty
	anchorId: StringProperty
}

const ColumnContainer = styled.div`
	width: 100%;

	& > div {
		padding-top: ${scale.px(20 / 8)};
		padding-bottom: ${scale.px(20 / 8)};
	}
	& > section {
		padding: 0;
		padding-top: ${scale.px(20 / 8)};
		padding-bottom: ${scale.px(20 / 8)};
	}
`

const CapioNexusSectionBlock: React.FC<SectionBlockProps> = (props) => {
	return (
		<Flex
			id={props.anchorId.value ?? null}
			mb={props.marginBottom?.value ? 3 : 0}
		>
			<BlockCommonLayout backgroundColor={props.backgroundColor}>
				{props.heading.value && (
					<Text pt={20 / 8} mb={1} variant="headline-2">
						{props.heading.value}
					</Text>
				)}
				<Flex
					w={1}
					flexWrap="wrap"
					justifyContent={{ _: "space-between", m: "flex-start" }}
					alignContent="start"
					columnGap={{ m: 3 }}
				>
					{props.mainContent?.value &&
						props.mainContent.value.map((block, i, array) => {
							const { id } = block.contentLink
							const blockType = getContentByType(block.modelType)

							return (
								<Flex
									key={id}
									flexGrow={0}
									flexShrink={1}
									flexBasis={{
										_: "100%",
										m: array.length === 1 ? "calc(100%)" : "calc(50% - 12px)",
										l:
											array.length === 1
												? "100%"
												: array.length === 2
												? "calc(50% - 12px)"
												: "calc(100% / 3 - 16px)",
									}}
								>
									<ColumnContainer>
										{React.createElement(blockType, {
											...(block && typeof blockType === "function" && block),
											key: id,
										})}
									</ColumnContainer>
								</Flex>
							)
						})}
				</Flex>
			</BlockCommonLayout>
		</Flex>
	)
}

export { CapioNexusSectionBlock }
